import { removeClass, addClass, removeEvent, addEvent, existy } from '../../utils';

import popoverPosition from './popoverPosition';
import openerHeightChecker from './openerHeightChecker';

const UP_CODE     = 38;
const DOWN_CODE   = 40;
const LEFT_CODE   = 37;
const RIGHT_CODE  = 39;
const ESC_CODE    = 27;

export default function handle(extension, {
   $button,
   $selector,
   SELECTOR_OPEN_CN,
   reposition = true,
   closeOnClick = false,
   heightControl = false,
   firstFocusItemSelector = '',
   toMainFn = () => {}
}) {
   let outerClickToken = null;

   extension.addEvent($button, 'click', toggle);

   if (!closeOnClick) {
      extension.addEvent($selector, 'click', e => e.stopPropagation() );
   }
   extension.addEvent(extension.player.getElement(), 'mouseleave', hide);
   extension.addEvent(extension.$selector, 'keydown', handleKeydown);
   extension.bus.on('resizeplayer', hide);

   function toggle() {
      if (existy(outerClickToken)) {
         hide();
      } else {
         show();
      }
   }

   // Accessability: Handle arrow keys press
   // TODO: This is not generic way, we can find better one
   // To be able to improve this we should refactor the way we rendering our extensions
   // Ex.: Remove hidden elements from DOM, fix the order of element rendering, etc.
   function handleKeydown(e) {
      e.stopPropagation();

      const keyCode = e.keyCode;
      const activeElement = document.activeElement;

      if (keyCode === ESC_CODE) {
         e.preventDefault();
         hide();
         extension.$button.focus();

         return;
      }

      // If nested menu, move to next step
      if (keyCode === RIGHT_CODE) {
         e.preventDefault();

         if (activeElement.classList.value.includes('__more')) {
            activeElement.click();
         }

         return;
      }

      // If nested menu, move to prev step
      if (keyCode === LEFT_CODE) {
         e.preventDefault();

         const allBackButtons = extension.$selector.querySelectorAll('button[class$="__back"]');
         const visibleBackButton = Array.from(allBackButtons).find((btn) => btn.offsetWidth > 0 || btn.offsetHeight > 0);

         if (visibleBackButton) visibleBackButton.click();

         return;
      }

      if (keyCode === DOWN_CODE) {
         e.preventDefault();
         let nextFocus = activeElement.nextElementSibling;
         nextFocus = checkVisibility(nextFocus, 'nextElementSibling');
         nextFocus = handleWrapperSibling(nextFocus, 'firstElementChild');

         if (!nextFocus) {
            nextFocus = handleWrapperParent(nextFocus, 'nextElementSibling');
         }

         if (nextFocus) nextFocus.focus();

         return;
      }

      if (keyCode === UP_CODE) {
         e.preventDefault();
         let prevFocus = activeElement.previousElementSibling;
         prevFocus = handleWrapperParent(prevFocus, 'previousElementSibling');
         prevFocus = checkVisibility(prevFocus, 'previousElementSibling');
         prevFocus = handleWrapperSibling(prevFocus, 'lastElementChild');

         if (prevFocus) prevFocus.focus();

      }
   }

   function handleWrapperParent(el, sibling) {
      const activeElement = document.activeElement;
      let element = el;
      // check if there is no next element and parent is wrapper
      const isInsideWrapper = !element && activeElement.parentElement.classList.value.includes('tab-content');

      if (isInsideWrapper) {
         element = activeElement.parentElement[sibling];
      }

      return element;
   }

   function handleWrapperSibling(el, child) {
      let element = el;
      // check if nextElement is wrapper element
      const isWrapper = element && element.classList.value.includes('tab-content');

      if (isWrapper) {
         element = element[child];
      }

      return element;
   }

   function checkVisibility(el, direction) {
      let element = el;
      let visible = el && (element.offsetWidth > 0 || element.offsetHeight > 0);

      while (!visible && element) {
         element = element[direction];
         visible = el && (element.offsetWidth > 0 || element.offsetHeight > 0);
      }

      return element;
   }

   function hide() {
      toMainFn();
      extension.bus.emit('hidepopup');
      removeClass($selector, SELECTOR_OPEN_CN);
      if (existy(outerClickToken)) {
         removeEvent(outerClickToken);
         outerClickToken = null;
      }
   }

   function show() {
      addClass($selector, SELECTOR_OPEN_CN);

      if (reposition) {
         popoverPosition(extension.player, $button, $selector);
      }

      setTimeout(() => {
         extension.bus.emit('showpopup', $selector);
         outerClickToken = addEvent(document, 'click', hide);
      });

      if (heightControl) {
         openerHeightChecker(extension.player, $selector);
      }

      // Accessability: If presented, focus on the first menu item
      if (firstFocusItemSelector) {
         setTimeout(() => {
            const firstFocusItem = $selector.querySelector(firstFocusItemSelector);
            firstFocusItem.focus();
         });
      }
   }
}
